/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Lymphatic_DrainageInputs */

const en_service_type_lymphatic_drainage = /** @type {(inputs: Service_Type_Lymphatic_DrainageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lymphatic drainage`)
};

const pl_service_type_lymphatic_drainage = /** @type {(inputs: Service_Type_Lymphatic_DrainageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drenaż limfatyczny`)
};

/**
* | output |
* | --- |
* | "Lymphatic drainage" |
*
* @param {Service_Type_Lymphatic_DrainageInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_lymphatic_drainage = /** @type {((inputs?: Service_Type_Lymphatic_DrainageInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Lymphatic_DrainageInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_lymphatic_drainage(inputs)
	return en_service_type_lymphatic_drainage(inputs)
});